import { useEffect, useState } from "react";

export default function StarRules({ apiFetch, onClose }) {
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    apiFetch("/star-rules").then(data => {
      if (cancelled) return;
      if (!data.rules) throw new Error(data.error || "Unable to load star rules.");
      setKeywords(data.rules.keywords);
      setLoaded(true);
    }).catch(err => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [apiFetch]);

  const save = async e => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      const data = await apiFetch("/star-rules", { method: "PUT", body: JSON.stringify({ keywords }) });
      if (!data.success) throw new Error(data.error || "Unable to save star rules.");
      onClose();
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="tpl-modal-overlay">
      <section className="tpl-modal star-rules-modal" role="dialog" aria-modal="true" aria-labelledby="star-rules-title">
        <div className="tpl-modal-header">
          <h3 id="star-rules-title">Star rules</h3>
          <button className="btn-icon" onClick={onClose} disabled={saving} aria-label="Close star rules">✕</button>
        </div>
        <form className="star-rules-form" onSubmit={save}>
          <p>Automatically star a lead when a new incoming message contains any configured word or phrase. Rules apply to all chats.</p>
          <p>Matching ignores case and repeated spaces, and matches whole words. Manual unstarring lasts until a new message matches a rule.</p>
          {error && <p className="star-error" role="alert">{error}</p>}
          {loading ? <p>Loading rules…</p> : loaded && <>
            {keywords.length === 0 && <p>No rules configured. Add a keyword to enable automatic starring.</p>}
            <div className="star-rule-list">
              {keywords.map((keyword, index) => (
                <div className="star-rule-row" key={index}>
                  <input aria-label={`Keyword ${index + 1}`} value={keyword} required maxLength={200} disabled={saving}
                    placeholder="Word or phrase" onChange={e => setKeywords(prev => prev.map((v, i) => i === index ? e.target.value : v))} />
                  <span>→ Star Lead</span>
                  <button type="button" className="btn-sm" disabled={saving} aria-label={`Remove keyword ${index + 1}`}
                    onClick={() => setKeywords(prev => prev.filter((_, i) => i !== index))}>Remove</button>
                </div>
              ))}
            </div>
            <button type="button" className="btn-sm" disabled={saving || keywords.length >= 100}
              onClick={() => setKeywords(prev => [...prev, ""])}>+ Add keyword</button>
            <p>Removing all keywords disables automation. Existing stars stay unchanged. These are literal rules and do not interpret sentiment or negation.</p>
          </>}
          <div className="star-rules-actions">
            <button type="button" className="btn-sm" onClick={onClose} disabled={saving}>Cancel</button>
            <button className="btn-primary" type="submit" disabled={!loaded || loading || saving}>{saving ? "Saving…" : "Save rules"}</button>
          </div>
        </form>
      </section>
    </div>
  );
}
